'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuListStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var size = function size(_ref) {
  var themeFromProvider = _ref.theme,
      inline = _ref.inline;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.menu.list,
      paddingY = _theme$reactackle$com.paddingY,
      paddingX = _theme$reactackle$com.paddingX;
  return inline ? (0, _styledComponents.css)(['padding:', ' ', ';'], (0, _reactackleCore.getValueString)(paddingX), (0, _reactackleCore.getValueString)(paddingY)) : (0, _styledComponents.css)(['padding:', ' ', ';'], (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX));
};

var inline = function inline(_ref2) {
  var inline = _ref2.inline;
  return inline && '\n  display: flex;\n  align-items: stretch;\n  flex-direction: row;\n';
};

var bordered = function bordered(_ref3) {
  var inline = _ref3.inline,
      bordered = _ref3.bordered,
      themeFromProvider = _ref3.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var borderDir = inline ? 'left' : 'top';
  var _theme$reactackle$com2 = theme.reactackle.components.menu.separator,
      thickness = _theme$reactackle$com2.thickness,
      color = _theme$reactackle$com2.color,
      style = _theme$reactackle$com2.style;
  return bordered && (0, _styledComponents.css)(['border-', ':', ' ', ' ', ';'], borderDir, (0, _reactackleCore.getValueString)(thickness), style, color);
};

var MenuListStyled = exports.MenuListStyled = _styledComponents2.default.ul.withConfig({
  displayName: 'MenuListStyled'
})(['margin:0;list-style-type:none;display:block;', ' ', ' ', ''], size, bordered, inline);

MenuListStyled.displayName = 'MenuListStyled';